import { useMemo, useState } from 'react'
import { type FieldValues, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

import { ReactComponent as RightArrow } from '../../components/assets/icons/rightArrow.svg'
import MainButton from '../../components/Button/MainButton'
import Header from '../../components/header/Header'
import MainText from '../../components/header/MainText'
import { API_URL } from '../../components/helpers/Helpers'
import SimpleInput from '../../components/inputs/SimpleInput'
import PlateHistory from '../../components/plate-history/PlateHistory'
import Wrapper from '../../components/wrapper/Wrapper'
import { licencePlateSchema } from '../../schema/schema'
import { plateHistoryUtils } from '../../utils/plate-history'

function Regularizar() {
  const navigate = useNavigate()
  const [isInternationalPlate, setIsInternationalPlate] = useState(false)

  const resolver = useMemo(
    () =>
      yupResolver(
        yup.object().shape({
          celular: yup
            .string()
            .min(11, 'Digite um número válido')
            .transform((value) => value.replace(/[^\d]/g, ''))
            .required(),
          licencePlate: licencePlateSchema(isInternationalPlate),
        }),
      ),
    [isInternationalPlate],
  )

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver,
  })

  const currentPlate = watch('licencePlate')
  const handlePlateSelect = (plate: string) => {
    setValue('licencePlate', plate)
  }

  async function submit(payload: FieldValues) {
    const response = await fetch(`${API_URL}/api/regularization-pix-code`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone: payload.celular, plate: payload.licencePlate }),
    })

    const data = await response.json()

    if (response.ok) {
      plateHistoryUtils.addPlateToHistory(payload.licencePlate)
      navigate(`/regularizar/${data.data.id}`)
    } else {
      console.error(data)
    }
  }

  return (
    <Wrapper>
      <Header />
      <MainText text="Olá, preencha os dados abaixo e siga tranquilo." />
      <form
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '30px',
        }}
        onSubmit={handleSubmit(submit)}
      >
        <SimpleInput
          title="PREENCHA O TELEFONE PARA UM CÓDIGO DE ACESSO"
          register={register}
          value={watch('celular')}
          name="celular"
          error={errors.celular}
        />

        <PlateHistory onPlateSelect={handlePlateSelect} currentPlate={currentPlate} />

        <SimpleInput
          title="PLACA DO VEÍCULO"
          register={register}
          name="licencePlate"
          isVehicle={true}
          value={currentPlate}
          error={errors.licencePlate}
          isInternationalPlate={isInternationalPlate}
          onToggleInternational={setIsInternationalPlate}
        />

        <MainButton type="submit" text="Receber código de acesso" icon={RightArrow} isLoading={isSubmitting} />
      </form>
    </Wrapper>
  )
}

export default Regularizar
